import CalendarRollUpExpanded from './CalendarRollUpExpanded';
import CalendarRollUpSummary from './CalendarRollUpSummary';
import { observer } from 'mobx-react-lite';
import { logUsage } from 'owa-analytics';
import CalendarRollUpViewState from 'owa-mail-reading-pane-store/lib/store/schema/CalendarRollUpViewState';
import { InstrumentationContext } from 'owa-mail-store';
import truncateCountForDataPointAggregation from 'owa-mail-store/lib/utils/truncateCountForDataPointAggregation';
import * as React from 'react';

const styles = require('./CalendarRollUp.scss');

export interface CalendarRollUpProps {
    calendarRollUpViewState: CalendarRollUpViewState;
    instrumentationContext: InstrumentationContext;
}

const CalendarRollUp = observer(function CalendarRollUp(props: CalendarRollUpProps) {
    React.useEffect(() => {
        logUsage('RPCalendarRollUpRendered', [
            props.calendarRollUpViewState.isExpanded,
            truncateCountForDataPointAggregation(
                props.calendarRollUpViewState.calendarReponseNodeIds.length
            ),
        ]);
    }, []);

    const { calendarRollUpViewState } = props;
    return (
        <div className={styles.calendarRollUp}>
            <CalendarRollUpSummary calendarRollUpViewState={calendarRollUpViewState} />
            {calendarRollUpViewState.isExpanded && <CalendarRollUpExpanded {...props} />}
        </div>
    );
});
export default CalendarRollUp;
